export const getLastChargeStatusIndicatorColor = (subscription) => {
  if (subscription.pendingPixPayment) return 'orange';

  if (subscription.lastChargeStatus === 'paid') return 'green';
  if (subscription.lastChargeStatus === 'pending') return 'orange';
  if (subscription.lastChargeStatus === 'processing') return 'orange';
  if (subscription.lastChargeStatus === 'active') return 'blue';
  if (subscription.lastChargeStatus === 'canceled') return 'red';
  if (subscription.lastChargeStatus === 'failed') return 'red';
  if (subscription.lastChargeStatus === 'rejected') return 'red';
  if (subscription.lastChargeStatus === 'unpaid') return 'red';
};

export const getStatusIndicatorColor = (subscription) => {
  if (subscription.pendingPixPayment) return 'orange';

  if (subscription.status === 'active') return 'green';
  if (subscription.status === 'canceled') return 'red';
  return 'grey';
};

export const getStatusText = (subscription) => {
  if (subscription.pendingPixPayment) return 'Pagamento pendente';

  if (subscription.status === 'active') return 'Ativa';
  if (subscription.status === 'canceled') return 'Cancelada';
};

export const getPaymentMethodText = (paymentMethod) => {
  if (paymentMethod === 'credit_card') return 'Cartão de Crédito';
  if (paymentMethod === 'pix') return 'Pix';
};

export const getLastChargeStatusText = (status) => {
  if (status === 'paid') return 'Pago';
  if (status === 'pending') return 'Pendente';
  if (status === 'processing') return 'Processando';
  if (status === 'active') return 'Aguardando cobrança';
  if (status === 'canceled') return 'Cancelado';
  if (status === 'failed') return 'Falhou';
  if (status === 'rejected') return 'Falhou';
  if (status === 'unpaid') return 'Falhou';

  return status;
};

export const isAwaitingFirstCharge = (subscription) => {
  return subscription.resumedFromId && subscription.lastChargeStatus === 'pending';
};

export const getOverdueDays = (lastChargeDueAt) => {
  if (!lastChargeDueAt) return 0;
  const dueDate = new Date(lastChargeDueAt);
  const now = new Date();
  const diffMs = now - dueDate;
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  return diffDays > 0 ? diffDays : 0;
};

export const getChargeFailureReason = (subscription) => {
  const message = subscription.lastChargeLastTransactionGatewayMessage;
  if (message) return message;

  const status = subscription.lastChargeStatus;
  if (status === 'declined' || status === 'rejected' || status === 'not_authorized') {
    return 'Cartão recusado — entre em contato com o banco ou operadora do cartão';
  }
  if (status === 'failed' || status === 'error' || status === 'with_error') {
    return 'Erro ao processar cobrança — tente novamente';
  }

  return null;
};

export const getPurchaseGroupStatusText = (groupStatus) => {
  if (groupStatus === 'sell') return 'Pago';
  if (groupStatus === 'refunded') return 'Reembolsado';
};

export const getPurchaseGroupStatusColor = (groupStatus) => {
  if (groupStatus === 'sell') return 'green';
  if (groupStatus === 'refunded') return 'red';
  return 'grey';
};
